<ridango-block-full-width role="radiogroup" aria-labelledby="product_quantity">
    <span class="step" role="text" attr.aria-label="{{ 'BLOCK_STEP_ARIA_LABEL' | translate }} {{ step }}">
        {{ step }}
    </span>
    <h2 class="block-full-width__title" id="product_quantity">{{ 'SELECT_QUANTITY' | translate }}</h2>

    <div class="flex flex-row items-center justify-center">
        <div class="flex flex-row items-center justify-center">
            <button
                class="btn btn--secondary btn--50x50 pn-dark:bg-contrast-white"
                [disabled]="quantity <= 1"
                [ngClass]="{ 'cursor-not-allowed opacity-50': quantity <= 1 }"
                (click)="amountChange(-1)"
                attr.aria-label="{{ 'DECREASE_AMOUNT_QUANTITY_ARIA_LABEL' | translate }} {{
                    'AMOUNT_QUANTITY_ARIA_LABEL' | translate
                }} {{ quantity }}">
                -
            </button>

            <div
                class="pn-dark:text-black flex h-[50px] w-14 cursor-pointer items-center justify-center bg-gray-100"
                *ngIf="!isEditing"
                (click)="onQuantityClick()"
                attr.aria-label="{{ 'EDIT_AMOUNT_QUANTITY_ARIA_LABEL' | translate }} {{ quantity }}">
                {{ quantity }}
            </div>

            <input
                class="h-[50px] w-14 bg-gray-100 text-center focus:outline-none"
                *ngIf="isEditing"
                [ngModel]="inputValue"
                [max]="maxQuantity"
                (ngModelChange)="inputValue = $event"
                (blur)="onInputBlur()"
                (keydown)="onInputKeyDown($event)"
                ridangoAutofocus
                type="number"
                inputmode="numeric"
                min="1"
                attr.aria-label="{{ 'EDIT_AMOUNT_QUANTITY_ARIA_LABEL' | translate }}" />

            <button
                class="btn btn--secondary btn--50x50 pn-dark:bg-contrast-white"
                [disabled]="quantity >= maxQuantity"
                [ngClass]="{ 'cursor-not-allowed opacity-50': quantity >= maxQuantity }"
                (click)="amountChange(1)"
                attr.aria-label="{{ 'INCREASE_AMOUNT_QUANTITY_ARIA_LABEL' | translate }} {{
                    'AMOUNT_QUANTITY_ARIA_LABEL' | translate
                }} {{ quantity }}">
                +
            </button>
        </div>
    </div>
</ridango-block-full-width>
